import httpRepo from '@/core/httpRepo'

export default {
	...httpRepo('command'),
	getAnswerPage(id, page) {
		return this.get(`${id}/answer/${page}`);
	},
};
